import { Experience } from '../types';

export const experienceData: Experience[] = [
  {
    id: 'valletta',
    company: 'Valletta.Software',
    position: 'Tech Lead / Full-Stack Developer',
    period: 'February 2025 — Present',
    duration: '1 year 3 months',
    description: 'Tech Lead delivering two client products for the US market: SoilSync and Zirtue.',
    achievements: [],
    projectSections: [
      {
        id: 'soilsync',
        achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4', 'achievement5'],
      },
      {
        id: 'zirtue',
        achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4', 'achievement5'],
      },
    ],
    technologies: ['NodeJS', 'NestJS', 'TypeORM', 'Prisma', 'PostgreSQL', 'AWS', 'AI Prompting'],
    website: 'https://vallettasoftware.com/',
    projectLinks: [
      { label: 'SoilSync', url: 'https://soilsync.bio' },
      { label: 'Zirtue', url: 'https://zirtue.com' },
    ],
  },
  {
    id: 'aithor',
    company: 'Aithor',
    position: 'FullStack Developer',
    period: 'July 2024 — November 2024',
    duration: '5 months',
    description: 'AI-powered platform development',
    achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4', 'achievement5'],
    technologies: ['React', 'Node.js', 'Stripe', 'Paddle', 'Auth0', 'OpenAI API', 'Qdrant'],
    website: 'https://aithor.com'
  },
  {
    id: 'impress',
    company: 'Impress',
    position: 'Fullstack Developer',
    period: 'July 2023 — July 2024',
    duration: '1 year 1 month',
    description: 'Full-stack development and system integration',
    achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4'],
    technologies: ['React', 'Node.js', 'NestJS', 'Stripe', 'Legacy Systems', 'System Integration'],
    website: 'https://smile2impress.com'
  },
  {
    id: 'infobip',
    company: 'Infobip LLC',
    position: 'Backend Developer',
    period: 'December 2018 — June 2023',
    duration: '4 years 6 months',
    description: 'Web infrastructure platform development',
    achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4', 'achievement5', 'achievement6'],
    technologies: ['Node.js', 'NestJS', 'GraphQL', 'Apollo Federation', 'Jenkins', 'Smartcat', 'Distributed Systems'],
    website: 'https://www.infobip.com'
  },
  {
    id: 'alfabank',
    company: 'Alfa-Bank',
    position: 'Lead Frontend Developer',
    period: 'January 2017 — December 2018',
    duration: '1 year 11 months',
    description: 'Banking applications development',
    achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4', 'achievement5'],
    technologies: ['React', 'React Native', 'Agile', 'Team Leadership', 'Mentoring'],
    website: 'https://www.alfabank.ru'
  },
  {
    id: 'semrush',
    company: 'SEMrush',
    position: 'Fullstack Developer',
    period: 'July 2015 — July 2016',
    duration: '1 year 1 month',
    description: 'Internal product development',
    achievements: ['achievement1', 'achievement2', 'achievement3', 'achievement4', 'achievement5'],
    technologies: ['Node.js', 'Selenium', 'Docker', 'Web Scraping', 'API Design', 'UI/UX'],
    website: 'https://semrush.com'
  },
  {
    id: 'geometria',
    company: 'Geometria.ru',
    position: 'Frontend Developer',
    period: 'December 2013 — July 2015',
    duration: '1 year 8 months',
    description: 'Frontend development with AngularJS',
    achievements: ['achievement1', 'achievement2', 'achievement3'],
    technologies: ['AngularJS', 'Grunt', 'Gulp', 'JavaScript', 'Frontend Optimization'],
    website: 'https://www.geometria.ru'
  },
  {
    id: 'realweb',
    company: 'RealWeb',
    position: 'Frontend/Backend Developer',
    period: 'December 2011 — May 2012',
    duration: '6 months',
    description: 'New company project development',
    achievements: ['achievement1', 'achievement2'],
    technologies: ['jQuery', 'ZendFramework', 'PHP', 'Frontend', 'Backend'],
    website: 'https://www.realweb.ru'
  },
  {
    id: 'realweb-early',
    company: 'RealWeb',
    position: 'Frontend Developer',
    period: 'November 2009 — December 2011',
    duration: '2 years 2 months',
    description: 'HTML coding and template integration',
    achievements: ['achievement1', 'achievement2', 'achievement3'],
    technologies: ['HTML', 'XSLT', 'Server-side Development'],
    website: 'https://www.realweb.ru'
  },
  {
    id: 'webmaster',
    company: 'Webmaster.spb',
    position: 'HTML Coder',
    period: 'April 2008 — October 2009',
    duration: '1 year 7 months',
    description: 'Commercial sites development',
    achievements: ['achievement1'],
    technologies: ['HTML', 'CSS', 'Commercial Websites'],
    website: 'https://www.webmaster.spb.ru'
  },
  {
    id: 'altitudo',
    company: 'Altitudo',
    position: 'HTML Coder',
    period: 'September 2007 — April 2008',
    duration: '8 months',
    description: 'Commercial sites and CMS integration',
    achievements: ['achievement1', 'achievement2'],
    technologies: ['HTML', 'CSS', 'UMI CMS', 'Template Integration'],
  },
  {
    id: 'freelance',
    company: 'Freelance',
    position: 'HTML coder',
    period: 'January 2007 — August 2007',
    duration: '8 months',
    description: 'Website creation and support',
    achievements: ['achievement1'],
    technologies: ['HTML', 'CSS', 'Website Development'],
  }
];
